import { useMemo } from 'react';
import { Run } from '@rossum/api-client/hooks';
import { isRunningJob } from '../helpers';

const CANCEL_THRESHOLD_MINUTES = 5;

const isCancelRequestOlderThanThreshold = (
  cancelRequestedAt: string | undefined | null
): boolean => {
  if (!cancelRequestedAt) return false;

  const date = new Date(cancelRequestedAt);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const minutes = Math.floor(diff / 1000 / 60);

  return minutes > CANCEL_THRESHOLD_MINUTES;
};

export const useRunCancelState = (run: Run) => {
  const isCancelling = !!run.cancelRequested && isRunningJob(run.status);

  const isCancelRequestTimedOut = useMemo(
    () =>
      !!isCancelling && isCancelRequestOlderThanThreshold(run.cancelRequested),
    [isCancelling, run.cancelRequested]
  );

  return {
    isCancelling,
    isCancelRequestTimedOut,
  };
};
